module.exports = __webpack_public_path__ + "static/media/whichThinnerNotAdjusted.90200731.mp3";